// frontend/src/charts/KpiCard.jsx
// The 'card' chart type: one number, labelled. Short value (12.9K) with
// the exact value on hover, both in the chart's number format (7b-2b) or,
// under "Automatic", the measure's own (13c-4; `columns` carry it).
// Text uses text ink only, never a series colour.
import React from 'react';
import { makeFormatter, presentationFor, seriesFormats } from './format';

export default function KpiCard({ chart, height = 320, presentation = null, columns = null }) {
  const series = (chart && chart.series && chart.series[0]) || null;
  const value = series && series.values && series.values.length ? series.values[0] : null;
  const own = presentationFor(presentation, seriesFormats(columns, 1)[0]);
  const shortText = makeFormatter(own, 'kpi');
  const exactText = makeFormatter(own, 'tooltip');
  return (
    <div style={{ height }} className="flex flex-col items-center justify-center gap-2 text-center">
      <div
        className="text-5xl font-semibold tracking-tight text-[color:var(--chart-text)]"
        title={exactText(value)}
      >
        {shortText(value)}
      </div>
      {series && series.name && (
        <div className="text-sm text-[color:var(--chart-text-secondary)]">{series.name}</div>
      )}
    </div>
  );
}
